// export const URL = '3.92.222.77';

const DEBUG = (window.location.hostname === "localhost");

if (DEBUG) {
  console.log('DEBUG MODE');
  var URL = 'http://localhost:8000';
} else {
  console.log('PRODUCTION MODE');
  // var URL = 'https://researchcompanion.onrender.com/';
  var URL = 'https://devonbrackbill.com';
};

export { URL, DEBUG };